import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Pagewrapper } from "../../components";
import Row from "react-bootstrap/Row";

const Ajuda = (props) => (
  <Pagewrapper {...props}>
    <Container>
      <Row>
        <Col>
          <h1 className="mt-5 text-center">Guia de Ajuda da Plataforma Jurídica LEX Editora</h1>
        </Col>
      </Row>      
    <p> </p>
    <p>Bem-vindo ao Guia de Ajuda da Plataforma Jurídica LEX Editora. Aqui você encontra orientações claras e objetivas para aproveitar todo o potencial das nossas ferramentas de pesquisa, navegação e consulta de conteúdo jurídico.</p>
    
    <p>Nosso objetivo é que sua experiência seja simples, intuitiva e eficiente, seja você um profissional experiente, estudante, pesquisador ou agente público.</p>
    
    <h2>1. Como realizar pesquisas</h2>
    <p>Aprenda a usar os recursos essenciais da plataforma:</p>
    <ul>
        <li><strong>Pesquisa Livre:</strong> digite palavras-chave, expressões ou trechos de interesse.</li>
        <li><strong>Filtros:</strong> refine seus resultados utilizando a opção "Filtros".</li>
    </ul>
    
    <h2>2. Navegação por Conteúdo</h2>
    <p>Entenda como encontrar rapidamente o tipo de informação que precisa:</p>
    <ul>
        <li>Legislação atualizada</li>
        <li>Jurisprudência completa</li>
        <li>Doutrina da LEX Editora</li>
        <li>Modelos e peças processuais</li>
    </ul>
    
    <h2>3. Salve documentos</h2>
    <p>Personalize sua experiência:</p>
    <ul>
        <li>Salve documentos importantes clicando em <strong>Salvar</strong></li>
    </ul>
    <p>Tudo fica sincronizado na sua conta.</p>
    
    <h2>4. Suporte ao Usuário</h2>
    <p>Caso não encontre a resposta desejada neste guia, entre em contato conosco:</p>
    <ul>
        <li><strong>E-mail:</strong> sac@lex.com.br</li>
        <li><strong>Horário de atendimento:</strong> Segunda a Sexta 08:30h às 18:00h</li>
        <li><strong>Telefone:</strong> 51 3191-3033</li>
    </ul>
    
    <p>Estamos aqui para facilitar sua jornada jurídica.</p>
    
    <p>Conte com a tradição, precisão e confiabilidade da LEX Editora para pesquisar com segurança e profundidade.</p>

    </Container>
  </Pagewrapper>
);

export default Ajuda;
